/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import EnvironmentModel from 'cio/models/environment';
import WhitelistedIpModel from 'cio/models/whitelisted-ip';

interface ApiCredentialsWhitelistTableComponentArgs {
  addresses: WhitelistedIpModel[];
  readOnly: boolean;
  environments: EnvironmentModel[];
  onConfirmDelete(address: WhitelistedIpModel): unknown;
  onCreateSubmit(address: WhitelistedIpModel): unknown;
}

export default class ApiCredentialsWhitelistTableComponent extends Component<ApiCredentialsWhitelistTableComponentArgs> {}
